import { Component, Input } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'ats-tip-accordion',
  imports: [TranslateModule, MatExpansionModule],
  templateUrl: './tip-accordion.component.html',
  styleUrl: './tip-accordion.component.css',
})
export class TipAccordionComponent {
  @Input() icon = 'an an-lightbulb';

  @Input({ required: true }) title!: string;

  @Input() expanded = false;
}
